module.exports = __webpack_public_path__ + "static/media/twenty-k-bold.dcffdc83.png";